import { useFormContext } from 'react-hook-form'

import { FormError, FormField, FormItem, FormLabel, RadioLarge } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/RunRiskCalibrationForm/RunRiskCalibrationForm.schema'
import { FUNDS, Fund } from '@/components/forms/RunRiskCalibrationForm/enums'

export interface FundsFieldProps {}

export const FundsField: React.FC<FundsFieldProps> = ({}) => {
  const { control, setValue, getValues } = useFormContext<SchemaType>()

  const handleToggleFund = (fundName: Fund) => {
    const oldValue = getValues('funds')

    const newValue = oldValue.includes(fundName)
      ? oldValue.filter((v) => v !== fundName)
      : [...oldValue, fundName]

    setValue('funds', newValue, { shouldValidate: true })
  }

  return (
    <FormField
      name="funds"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Funds</FormLabel>
              <FormError />
            </div>
            <div className="grid grid-cols-4 gap-2">
              {FUNDS.map((fund) => {
                const selected = field.value?.includes(fund)

                return (
                  <RadioLarge
                    {...field}
                    type="checkbox"
                    value={fund}
                    checked={selected}
                    key={fund}
                    onChange={() => handleToggleFund(fund)}
                  >
                    {fund}
                  </RadioLarge>
                )
              })}
            </div>
          </FormItem>
        )
      }}
    />
  )
}
